import { apiService } from '@/services/APIService';

export default {
  // получение списка регионов для авторизации
  getSubordinations(params) {
    return apiService.get('/event-subordinations', params);
  },
  getLevelInfo(id, params) {
    return apiService.get(`/public/event-subordinations/level-info/${id}`, params);
  },
  getEventsCount(id, params) {
    return apiService.get(`/public/event-subordinations/level-events-count/${id}`, params);
  },
  getAreaInfo(id, params) {
    return apiService.get(`/public/event-subordinations/level-area-info/${id}`, params);
  },

  createSubordination(params) {
    return apiService.post('/event-subordinations', params);
  },

  deleteSubordination(id) {
    return apiService.delete(`/event-subordinations/${id}`);
  },

  createEventSubordination(id) {
    return apiService.post(`/event-subordinations/${id}/create-event`);
  },

  getSubordinationUsers(id, params) {
    return apiService.get(`/event-subordinations/${id}/users`, params);
  },

  completeSubordinationUsers(id, params) {
    return apiService.post(`/event-subordinations/${id}/users-confirm`, params);
  },

  rejectSubordinationUsers(id, params) {
    return apiService.post(`/event-subordinations/${id}/users-reject`, params);
  },

  completeSubordinationTeams(id, params) {
    return apiService.post(`/event-subordinations/${id}/teams-confirm`, params);
  },

  rejectSubordinationTeams(id, params) {
    return apiService.post(`/event-subordinations/${id}/teams-reject`, params);
  },

  attachEventSubordinationUsers(id, params) {
    return apiService.post(`/event-subordinations/${id}/users`, params);
  },

  detachEventSubordinationUsers(id, params) {
    return apiService.delete(`/event-subordinations/${id}/users`, { params });
  },
  attachEventSubordinationTeams(id, params) {
    return apiService.post(`/event-subordinations/${id}/teams`, params);
  },
  detachEventSubordinationTeams(id, params) {
    return apiService.delete(`/event-subordinations/${id}/teams`, { params });
  },
  getSubordinationTeams(id, params) {
    return apiService.get(`/event-subordinations/${id}/teams`, params);
  },

  detachByMainEventSubordinationTeams(id, params) {
    return apiService.delete(`/event-subordinations/${id}/teams-by-main-event`, { params });
  },
  detachByMainEventSubordinationUsers(id, params) {
    return apiService.delete(`/event-subordinations/${id}/users-by-main-event`, params);
  },
};
